import { render } from "./TestQuestionCaptcha.vue?vue&type=template&id=2e3a48b8&scoped=true"
import script from "./TestQuestionCaptcha.vue?vue&type=script&lang=js"
export * from "./TestQuestionCaptcha.vue?vue&type=script&lang=js"

import "./TestQuestionCaptcha.vue?vue&type=style&index=0&id=2e3a48b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3a48b8"]])

export default __exports__